import { Box, Heading, Text } from '@wix/design-system'
import React, { ComponentProps, FC, ReactNode } from 'react'

import { SkipButton } from '../SkipButton'
import { dataHooks } from './CommonTemplate.dataHooks'
import s from './CommonTemplate.scss'

type CommonTemplateLayoutProps = {
  dataHook?: string

  subTitleAbove?: string
  title?: ReactNode
  titleSize?: ComponentProps<typeof Heading>['size']
  subTitleBelow?: string

  skipButton?: string
  skipButtonClassName?: string
  onSkipClick?: () => void

  sidePanel?: ReactNode

  logo?: ReactNode
  bottomNote?: ReactNode

  className?: string
}

export const CommonTemplateLayout: FC<CommonTemplateLayoutProps> = ({
  dataHook,
  subTitleAbove,
  title,
  titleSize = 'extraLarge',
  subTitleBelow,
  skipButton,
  skipButtonClassName,
  onSkipClick,
  sidePanel,
  className,
  children,
  bottomNote,
  logo,
}) => (
  <Box direction="horizontal" minHeight="100vh" width="100%" dataHook={dataHook}>
    {logo}
    <Box
      flex="1"
      direction="vertical"
      padding="0px 90px 0px 142px"
      position="relative"
      className={className}
      verticalAlign="middle"
    >
      {/* top spacer */}
      <div className={s.CommonTemplateLayout__topSpacer} />

      {/* title/subtitle */}
      <Box direction="vertical" gap="12px">
        {subTitleAbove && (
          <Text weight="bold" size="medium" secondary className={s.subTitleAbove} dataHook={dataHooks.subTitleAbove()}>
            {subTitleAbove}
          </Text>
        )}
        {title && (
          <Heading size={titleSize} dataHook={dataHooks.title()}>
            {title}
          </Heading>
        )}
        {subTitleBelow && (
          <Text weight="thin" size="medium" secondary dataHook={dataHooks.subTitleBelow()}>
            {subTitleBelow}
          </Text>
        )}
      </Box>

      {/* passed content */}
      {children}

      {/* absolutely positioned skip */}
      {skipButton && (
        <SkipButton
          className={skipButtonClassName}
          skipButton={skipButton}
          onClick={onSkipClick}
          position="bottomRight"
          dataHook={dataHooks.skip()}
        />
      )}

      {/* bottom spacer */}
      <div className={s.CommonTemplateLayout__bottomSpacer} />

      {/* bottom note */}
      {bottomNote && <div className={s.CommonTemplateLayout__bottomNote}>{bottomNote}</div>}
    </Box>
    {sidePanel}
  </Box>
)
